export interface PlaceOfBirthInterface {
	country: string,
	township: string,
}

export class PlaceOfBirthClass implements PlaceOfBirthInterface {
	country = '';
	township = '';
}
